import { UpCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import { motion } from "framer-motion";

export const backtoTopFunction = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

const BacktoTop = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginRight: "1vw",
      }}
    >
      <Button
        type="primary"
        onClick={() => backtoTopFunction("/")}
        ghost={true}
      >
        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
          <p>
            <UpCircleFilled />
            Back to Top
          </p>
        </motion.div>
      </Button>
    </div>
  );
};

export default BacktoTop;
